'use client';
import { IconArrow } from '@moar/svg';
import Link from 'next/link';
import { useEffect, useState } from 'react';

const TIMELINE = '/sections';

// Where "Return to Timeline" goes, best source first:
// 1. `back` — the in app path the glossary was opened from. Every glossary tooltip sets it, so it
//    is the only source that survives client side navigation (see use-glossary).
// 2. `section` — older/cached glossary links: an anchor (object or section) on the timeline.
// 3. document.referrer — only says anything when the glossary was opened by a full page load, and
//    it has no hash, so it is a last resort before falling back to the timeline.
const getPrevPage = () => {
    const params = new URLSearchParams(window.location.search);

    // reject anything that is not an in app path, `//host` included
    const back = params.get('back');
    if (back && back.startsWith('/') && !back.startsWith('//')) return back;

    const section = params.get('section');
    if (section) return `${TIMELINE}#${section}`;

    try {
        const referrer = new URL(document.referrer);
        // a referrer of this same page (the glossary, with or without a query) would link to nowhere
        if (referrer.origin === window.location.origin && referrer.pathname !== window.location.pathname) {
            return `${referrer.pathname}${referrer.search}${referrer.hash}`;
        }
    } catch {
        // no referrer: navigated to client side, opened directly, or came from another site
    }

    return TIMELINE;
};

export function BackToTimelineNav() {
    // resolved after mount: window/document are not there while rendering on the server
    const [prevPage, setPrevPage] = useState(TIMELINE);

    useEffect(() => {
        setPrevPage(getPrevPage());
    }, []);

    return (
        <div className="print:hidden">
            <Link href={prevPage} className="flex items-baseline font-bold link--dark lg:justify-start group">
                <IconArrow color="blue" />
                <span className="ml-2 text-xs md:text-sm">Return to Timeline</span>
            </Link>
        </div>
    );
}

export default BackToTimelineNav;
